import React from "react"

import Button, {
    ButtonProps,
} from "react-bootstrap/Button"

import "./style.css"

export type EMETLNavButtonProps = ButtonProps & {
    children: React.ReactNode,
    style?: React.CSSProperties,
}

const EMETLNavButton = (props: EMETLNavButtonProps) => {
    const { 
        children, 
        style = {},
        onClick,
        className = "",
    } = props

    return (
        <Button 
            variant="light"
            className={`navButton ${className}`}
            onClick={onClick}
            style={style}
        >
            {children}
        </Button>
    )
}

export default EMETLNavButton